import React from "react";
import { CheckBox, TextBox } from "devextreme-react";
import { useSelector } from "react-redux";
import { selectContract } from "../../../redux/contract/selectors";

function SendMailSmsForm(props){

    const { classes, dataSms, onValueChange } = props;
    const contract = useSelector(selectContract);
    const originalEmail = contract.contractData?.email? contract.contractData.email : "";

    function onValueChangeSendMail(value){
        onValueChange("email", originalEmail);
        onValueChange("sendMail", value);
    }

    return (
            <>
                <div className={classes.input_grid}>
                    <InputWrapper classes={classes} label="Enviar email">
                        <CheckBox value={dataSms.sendMail} onValueChanged={(e) => onValueChangeSendMail(e.value)} className={classes.controlers}  height={25} style={{marginTop: 0}}></CheckBox>
                    </InputWrapper>
                </div>
                {dataSms.sendMail &&
                <InputWrapper classes={classes} label="Enviar email">
                    <TextBox key={"email"} name="email" value={dataSms.email} onValueChanged={(e) => onValueChange("email", e.value)} className={classes.controlers} height={25} />
                </InputWrapper>}
            </>
    )
}

function InputWrapper(props){
    const {classes, label} = props;
        return(
            <div className="dx-field">
            <label className={classes.label}>{label}</label> 
                <div style={{width:"100%"}} className="dx-field-value">
                    {props.children}
                </div>
        </div>
        )
    }

export default SendMailSmsForm;